module.exports = __webpack_public_path__ + "img/PDPA-1.d0595bc6.png";